(function (angular) {
    'use strict';

    angular.module('Common')
        .factory('permissionService', ['permissionTreeConfig', function (permissionTreeConfig) {

            var permissions;
            var permissionTree;

            function buildTree(permissionTreePart) {
                for (var generalPermissionKey in permissionTreePart) {
                    var generalPermission = permissionTreePart[generalPermissionKey];
                    var requiredPermissionsCount = generalPermission.requiredPermissions ? generalPermission.requiredPermissions.length : -1;
                    if(generalPermission.requiredPermissions){
                        for(var permission in generalPermission.requiredPermissions){
                            if(permissions.includes(generalPermission.requiredPermissions[permission])){
                                requiredPermissionsCount--;
                            }
                        }
                    }

                    if (generalPermission.children) {
                        if (buildTree(generalPermission.children) && requiredPermissionsCount <= 0) {
                            generalPermission.display = true;
                        }
                    }
                    if (requiredPermissionsCount === 0) {
                        generalPermission.display = true;
                    }
                }
                return generalPermission.display;
            }

            function getPermission(request) {
                request = request.split("(")[0].split(".");
                var permission = permissionTree;
                if (!permission && (request[0] == 'register' || request[0] == 'thanks' || request[0] == 'resetPassword' || request[0] == 'login' || request[0] == 'totp' || request[0] == 'emailvalidate' || request[0] == 'accessDenied')) {
                    return { display: true };
                } else if (!permission) {
                    return { display: true };
                }
                for (var i = 0; i < request.length; i++) {
                    permission = permission[request[i]];
                    if (!permission) {
                        return false;
                    }
                    if (i + 1 < request.length) {
                        permission = permission.children;
                    }
                }
                return permission;
            }

            var fac = {
                //pass permission from jwt to build permission tree
                buildTree: function(jwtPermissions){
                    permissions = jwtPermissions;
                    permissionTree = new permissionTreeConfig.PermissionsTreeSchema();
                    buildTree(permissionTree);
                },
                //check single permission e.g. "apis:w"
                checkPermission: function (permission) {
                    return permissions.includes(permission);
                },
                //check multiple permissions and return true if all there e.g. ["apis:w", "apis:w"]
                checkPermissions: function (permissionsToCheck) {
                    return permissionsToCheck.every(function(r){
                        return permissions.includes(r);
                    });
                },
                //check privilege to display picked state e.g "main.apiSpace"
                checkPrivilegeToDisplay: function (state) {
                    var permissions = getPermission(state);

                    if (permissions && permissions.display) {
                        return true;
                    }
                    return false;
                }

            }

            return fac;
        }]);
})(window.angular);